module.exports = __webpack_public_path__ + "img/opened_courses.bf31d188.svg";